<div class="tile" [ngClass]="isTouch ? 'tablet' : 'desktop'">
  <ion-card
    [ngClass]="'ion-card-tile-' + platformEnum"
    [class.no-button]="!textButton"
    (click)="!textButton && actionClick()"
  >
    <!-- BADGE -->
    <ion-badge
      *ngIf="badgeText !== undefined"
      [color]="badgeColor"
      mode="ios"
      data-cy="badge-text"
    >
      {{ badgeText }}
    </ion-badge>

    <!-- TITLE -->
    <h2
      [ngStyle]="shouldCenterTitle && { 'text-align': 'center' }"
      [attr.data-cy]="'payments-tile-title-' + getDataCyAttr(title)"
    >
      {{ title }}
    </h2>

    <!-- BODY -->
    <p [attr.data-cy]="'payments-tile-text-' + getDataCyAttr(title)">
      {{ textBody }}
    </p>

    <div *ngIf="textButton !== ''" class="payments-tile-btn-container">
      <ion-button
        [attr.data-cy]="'payments-tile-btn-' + getDataCyAttr(title)"
        [ngClass]="'usf-outline-green-dsktp-tblt-modal-button'"
        (click)="actionClick()"
      >
        {{ textButton }}
        <ion-icon
          *ngIf="iconButton === 'external-link'"
          src="assets/icon/external-link-green.svg"
        ></ion-icon>
      </ion-button>
    </div>
  </ion-card>
</div>
